module.exports = "/_next/static/images/67227676212bea99302a24436bab6cb5-add-person-avatar-4x.png";